import { 
  Box, 
  Button, 
  VStack, 
  Text, 
  FormControl, 
  FormLabel, 
  Input,
  FormErrorMessage,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useAddReportTo } from "../../services/configurationService";
import { FiUserCheck } from "react-icons/fi";

const AddReportTo = ({ closeModal, editReportTo, todo, editReportToPayload, editReportToIsLoading, refetchGetReportTo }) => {
  const [inputData, setInputData] = useState({ name: "" });
  const [errors, setErrors] = useState({});
  
  const { addReportToIsLoading, addReportToPayload } = useAddReportTo((res) => {
    refetchGetReportTo();
    closeModal();
  });

  const validateForm = () => {
    const newErrors = {};
    if (!inputData.name.trim()) {
      newErrors.name = "Reporting senior name is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    const payload = {
      id: todo === "edit" ? editReportTo?.id : "",
      name: inputData.name.trim(),
    };

    if (todo === "new") {
      addReportToPayload(payload);
    } else {
      editReportToPayload(payload);
    }
  };

  useEffect(() => {
    if (editReportTo?.name) {
      setInputData({ name: editReportTo.name });
    }
  }, [editReportTo]);

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <VStack spacing={6} align="stretch">
          {/* Header */}
          <VStack spacing={2} align="center">
            <Box
              p={3}
              borderRadius="12px"
              bg="purple.50"
              color="purple.600"
              border="1px solid"
              borderColor="purple.200"
            >
              <FiUserCheck size={24} />
            </Box>
            <VStack spacing={1}>
              <Text fontSize="lg" fontWeight="600" color="gray.900">
                {todo === "edit" ? "Edit" : "Add"} Reporting Senior
              </Text>
              <Text fontSize="sm" color="gray.500" textAlign="center">
                {todo === "edit" ? "Update reporting senior information" : "Enter reporting senior details"}
              </Text>
            </VStack>
          </VStack>

          {/* Form Fields */}
          <FormControl isInvalid={!!errors.name}>
            <FormLabel fontSize="sm" fontWeight="500" color="gray.700">
              Reporting Senior Name
            </FormLabel>
            <Input
              placeholder="Enter reporting senior name"
              value={inputData.name}
              onChange={(e) => setInputData({ ...inputData, name: e.target.value })}
              borderRadius="12px"
              borderColor="gray.200"
              _focus={{ borderColor: "purple.500", boxShadow: "0 0 0 1px var(--chakra-colors-purple-500)" }}
              _hover={{ borderColor: "gray.300" }}
              size="lg"
            />
            <FormErrorMessage>{errors.name}</FormErrorMessage>
          </FormControl>

          {/* Submit Button */}
          <Button
            type="submit"
            colorScheme="purple"
            size="lg"
            borderRadius="12px"
            fontWeight="600"
            isLoading={addReportToIsLoading || editReportToIsLoading}
            loadingText={todo === "edit" ? "Updating..." : "Adding..."}
            _hover={{ transform: "translateY(-1px)", boxShadow: "lg" }}
            transition="all 0.2s"
          >
            {todo === "edit" ? "Update Reporting Senior" : "Add Reporting Senior"}
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default AddReportTo;
